import React from 'react';
import { Logo } from './Logo';

interface SessionWarningModalProps {
  onStaySignedIn: () => void;
  onSignOut: () => void;
  secondsRemaining: number;
}

export const SessionWarningModal: React.FC<SessionWarningModalProps> = ({
  onStaySignedIn,
  onSignOut,
  secondsRemaining,
}) => {
  const minutes = Math.floor(secondsRemaining / 60);
  const seconds = String(secondsRemaining % 60).padStart(2, '0');

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-ink/60 backdrop-blur-sm overflow-y-auto">
      <div className="relative z-10 w-full max-w-md my-8 oi-overlay p-8 md:p-10">

        {/* Editorial header — Logo mark + section label */}
        <div className="flex items-center gap-3 mb-8 pb-5 border-b border-ink-200">
          <Logo variant="mark" size={26} />
          <span className="text-[10px] font-medium uppercase tracking-widest text-ink-500">Session Security</span>
        </div>

        <h2 className="text-2xl font-serif font-medium text-ink mb-3">Session Expiring Soon</h2>

        <p className="text-ink-600 mb-8 leading-relaxed text-sm">
          You've been inactive for nearly 30 minutes. For your security,
          Oracle Insight will automatically sign you out in:
        </p>

        {/* Timer — left-aligned, tabular figures */}
        <div className="text-6xl font-mono font-medium tracking-tight tabular-nums text-ink mb-10">
          {minutes}:{seconds}
        </div>

        <div className="flex flex-col gap-3">
          <button
            onClick={onStaySignedIn}
            className="w-full bg-oxblood text-paper font-medium tracking-wide py-3 rounded-md hover:bg-oxblood-800 transition-colors text-sm"
          >
            Stay Signed In
          </button>

          <button
            onClick={onSignOut}
            className="w-full bg-transparent border border-ink-200 text-ink font-medium tracking-wide py-3 rounded-md hover:bg-surface-2 transition-colors text-sm"
          >
            Sign Out Now
          </button>
        </div>
      </div>
    </div>
  );
};
